import * as tslib_1 from "tslib";
import addInfoBarMessage from './addInfoBarMessage';
import removeInfoBarMessage from './removeInfoBarMessage';
import setIRMData from './setIRMData';
import getEncryptionInfoBarMessageId from '../utils/getEncryptionInfoBarMessageId';
import { action } from 'satcheljs/lib/legacy';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
export default action('protectMessage')(function protectMessage(viewState, complianceConfigurations, templateId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var IRMData;
        return tslib_1.__generator(this, function (_a) {
            // Set IRM data when
            // 1. IRMData is null, or
            // 2. IRMData is of a different template type
            if (!viewState.IRMData || viewState.IRMData.RmsTemplateId != templateId) {
                if (viewState.IRMData) {
                    removeInfoBarMessage(viewState, getEncryptionInfoBarMessageId(viewState.IRMData.RmsTemplateId));
                }
                IRMData = createIRMData(viewState, complianceConfigurations.get(templateId));
                if (IRMData) {
                    setIRMData(viewState, IRMData);
                    addInfoBarMessage(viewState, getEncryptionInfoBarMessageId(IRMData.RmsTemplateId));
                }
            }
            return [2 /*return*/];
        });
    });
});
function createIRMData(viewState, sourceData) {
    var userConfig = getUserConfiguration();
    var licenseData;
    if (sourceData) {
        licenseData = {
            RmsTemplateId: sourceData.RmsTemplateId,
            IsOwner: true,
            RightsManagedMessageDecryptionStatus: 0 /* Success */,
            TemplateName: sourceData.TemplateName,
            TemplateDescription: sourceData.TemplateDescription,
            BodyType: viewState.bodyType,
            ContentOwner: userConfig.SessionSettings.UserEmailAddress,
            EditAllowed: false,
            ReplyAllowed: false,
            ReplyAllAllowed: false,
            ForwardAllowed: false,
            PrintAllowed: false,
            ExtractAllowed: false,
            ProgrammaticAccessAllowed: false,
        };
    }
    return licenseData;
}
//# sourceMappingURL=protectMessage.js.map